// Visit tracking needs a server-side database, and the site has none (all content is in the code).
// These no-ops keep PageTracker / AnalyticsDashboard working without recording anything.
// For traffic numbers, use Netlify Analytics or a hosted analytics script instead.
class AnalyticsService {
  async trackPageVisit() {}

  async getAnalytics() {
    return null;
  }

  async getPageVisits() {
    return [];
  }
}

export const analyticsService = new AnalyticsService();
